// faqBlock.ts
export function initFaqBlock(): void {
    const items = document.querySelectorAll<HTMLButtonElement>(".faq-block__item__question");

    items.forEach(button => {
        button.addEventListener("click", () => {
            const answer = button.nextElementSibling as HTMLElement | null;
            if (!answer) return;

            button.classList.toggle("active");

            if (answer.style.maxHeight && answer.style.maxHeight !== "0px") {
                answer.style.maxHeight = "0";
            } else {
                answer.style.maxHeight = `${answer.scrollHeight}px`;
            }
        });
    });
}